export const itemHeaderMarkAsJunk = "Hnc";
export const itemHeaderReportJunk = "Inc";
export default {itemHeaderMarkAsJunk,itemHeaderReportJunk};